import ChangesCompanyTemplate from "../../templates/ChangesCompanyTemplate/ChangesCompanyTemplate";

const ChangesCompanyPage = () => {
  return <ChangesCompanyTemplate />;
};

export default ChangesCompanyPage;
